import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'underscore';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { CardsBoard, CardContainer } from '@bingads-webui-react/cards-board';
import { HelpPopupTitle } from '../help-popup-title';
import { getTopKeyCardStyles } from '../../styles/top-key-card';

export const TopKeyCardGroup = ({
  i18n,
  cards,
  cardNumber,
}) => {
  const classes = useDefaultStyles(getTopKeyCardStyles);
  const cardGroup = _.map(cards, (cardConfig) => {
    const {
      cardType, headerConfig, content, footer,
    } = cardConfig;

    const header = (<HelpPopupTitle
      i18n={i18n}
      nameKey={headerConfig.titleKey}
      helpTopic={headerConfig.helpTopic}
      itemNameKey={headerConfig.itemNameKey}
    />);

    return {
      key: `${cardType}`,
      occupiedColNumber: 1,
      cardContainer: (
        <CardContainer
          title={header}
          content={content}
          footer={footer}
          className={classnames('top-key-card', `top-key-card-${cardType}`)}
        />
      ),
    };
  });

  return (
    <CardsBoard
      className={`top-key-card-group ${classes.TopKeyCardGroup}`}
      cards={cardGroup}
      colNumber={cardNumber}
      defaultColMinWidth={200}
      isAutoFillBlankDisabled
    />
  );
};

TopKeyCardGroup.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  cards: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  cardNumber: PropTypes.number.isRequired,
};

TopKeyCardGroup.defaultProps = {
};
